"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var GoogleSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M8.9993443,14 C6.21362257,14 3.9993443,11.7856783 3.9993443,9 C3.9993443,6.21432168 6.21362257,4 8.9993443,4 C10.3565008,4 11.4993443,4.5 12.3564661,5.3571565 L10.9993096,6.64286086 C10.6421791,6.28573041 9.99932689,5.85714782 8.99930089,5.85714782 C7.28505737,5.85714782 5.92790084,7.28571305 5.92790084,9.00000001 C5.92790084,10.7142869 7.28505737,12.1428522 8.99930089,12.1428522 C10.9993096,12.1428522 11.7135705,10.7142869 11.8564313,9.99998262 L8.99930089,9.99998262 L8.99930089,8.2856957 L13.7135792,8.2856957 C13.7850313,8.57141739 13.7850313,8.78568697 13.7850313,9.14286086 C13.7850747,11.9999913 11.8564747,14 8.9993443,14 Z" })));
};
GoogleSmall.displayName = 'GoogleSmall';
exports.default = GoogleSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=GoogleSmall.js.map